import { customerWaiverModel } from './customer-waivers-model'

export const customerWaiverSystemView = customerWaiverModel
